import { FontFamily } from '@/types';
import { getParams } from '@/utils/params';
import { fetchFromApi } from './fetchFromApi';

export const fetchFontFamilies = () =>
  fetchFromApi<{ fontFamilies: FontFamily[] }>(
    `${getParams().context}s/${getParams().contextId}/fontFamilies`,
    { fullData: true, limit: 200 }
  ).then((data) => data.fontFamilies);
